import { RectangleChip } from "../../../../../../shared/chip/rectangle-chip.styles";
import { AttachMoney } from '@mui/icons-material';

export const getBalanceChip = (balance: number) => {

  const getColors = (balance: number) => {
    if (balance === 0) return { color: 'rgba(122, 134, 154, 1)', backgroundColor: 'rgba(240, 241, 244, 1)' }
    else if (balance > 0) return { color: 'rgba(0, 138, 6, 1)', backgroundColor: 'rgb(237, 247, 237)' }
    else return { color: 'rgba(195, 55, 49, 1)', backgroundColor: 'rgba(226, 86, 80, 0.16)' }
  }

  return <RectangleChip sx={{...getColors(balance)}}>
    <AttachMoney sx={{ fontSize: '15px' }} />
  </RectangleChip>;
};